/* eslint-disable no-restricted-syntax -- Not translatable strings */

export const FONT_FAMILY_OPTIONS = [
  {
    label: "System UI",
    value: "system-ui",
    group: "web-font",
  },
  {
    label: "Inter",
    value: "InterVariable",
    group: "web-font",
  },
  {
    label: "Arial",
    value: "Arial, sans-serif",
    group: "web-font",
  },
  {
    label: "Helvetica",
    value: "Helvetica, sans-serif",
    group: "web-font",
  },
  {
    label: "Verdana",
    value: "Verdana, sans-serif",
    group: "web-font",
  },
  {
    label: "Tahoma",
    value: "Tahoma, sans-serif",
    group: "web-font",
  },
  {
    label: "Trebuchet MS",
    value: "'Trebuchet MS', sans-serif",
    group: "web-font",
  },
  {
    label: "Times New Roman",
    value: "'Times New Roman', serif",
    group: "web-font",
  },
  {
    label: "Times",
    value: "Times, serif",
    group: "web-font",
  },
  {
    label: "Georgia",
    value: "Georgia, serif",
    group: "web-font",
  },
  {
    label: "Courier New",
    value: "'Courier New', monospace",
    group: "web-font",
  },
  {
    label: "Courier",
    value: "Courier, monospace",
    group: "web-font",
  },
  {
    label: "Consolas",
    value: "Consolas, monospace",
    group: "web-font",
  },
  {
    label: "Sans-serif",
    value: "sans-serif",
    group: "web-font",
  },
  {
    label: "Serif",
    value: "serif",
    group: "web-font",
  },
  {
    label: "Monospace",
    value: "monospace",
    group: "web-font",
  },
];
